export default "__VITE_ASSET__DM8ZIG6C__"